// @ts-nocheck - Table/SimpleTextFilter/CompanyLink/formatter
import React, { useState } from 'react';
import { loadCompaniesWithOpenRequests } from '../../../actions/companyActions';
import { NavLink, useLocation } from 'react-router-dom';
import { Table, SimpleTextFilter, getVisibleColumns } from '../../common/Table';

import { CommaNumber_NoDecimal } from '../../../util/formatter';

import Loading from '../../common/Loading';
import KwPanel from '../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../hooks/useTableSettings';
import CompanyLink from '../../common/links/CompanyLink';
import { scopes as tableScopes } from '../../../constants/scopes';
import { useTranslation } from 'react-i18next';

export interface CompanyStatsProps {
  reload?: any;
}

function CompanyStats({ reload }: CompanyStatsProps) {
  const location = useLocation();
  const { t } = useTranslation();
  const allColumns = [
    'companyName',
    'requestsOpen',
    'requestsComplete',
    'keysRequested',
  ];
  const defaultVisibleColumns = allColumns;
  const [companies, setCompanies] = useState<any>();
  const params = new URLSearchParams(location.search);
  const { tableSettings, handleSetTableSettings: setTableSettings, filters, filterChange, isLoading } =
    useTableSettings(
      'home-company-openrequests-settings',
      getTableSettingsDefaults({
        defaultSort: 'requestsOpen',
        direction: 'desc',
        defaultVisibleColumns,
      }),
      null,
      loadCompaniesWithOpenRequests,
      setCompanies,
      reload,
      t('Failed to load companies')
    );

  const columnsConfig = [
    {
      Key: 'companyName',
      Label: t('Company'),
      Render: (item: any) => (
        <CompanyLink id={item.id} name={item.companyName} imageSize={32} />
      ),
      Filter: {
        Render: (col: any) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value: string) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'requestsOpen',
      Label: t('Open'),
      className: 'text-right num no-wrap',
      Render: (item: any) => (
        <NavLink
          to={`/requests/all?${tableScopes.EXCLUDEARCHIVEDTITLES}&${tableScopes.ISPENDING}=true&${tableScopes.COMPANY}=${item.id}`}
        >
          {CommaNumber_NoDecimal(item.requestsOpen)}
        </NavLink>
      ),
    },
    {
      Key: 'requestsComplete',
      Label: t('Complete'),
      className: 'text-right num no-wrap',
      Render: (item: any) => (
        <NavLink
          to={`/requests/all?${tableScopes.EXCLUDEARCHIVEDTITLES}=true&${tableScopes.ISAUTHORISED}=true&${tableScopes.COMPANY}=${item.id}`}
        >
          {CommaNumber_NoDecimal(item.requestsComplete)}
        </NavLink>
      ),
    },
    {
      Key: 'keysRequested',
      Label: t('Total keys'),
      className: 'text-right num no-wrap',
      Render: (item: any) => CommaNumber_NoDecimal(item.keysRequested),
    },
  ];

  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);

  return companies ? (
    <KwPanel className="mb-4">
      <header className="mb-3">
        <h2 className="no-margin">{t('Companies with open requests')}</h2>
      </header>
      <Table
        columns={columns}
        allColumns={allColumns}
        rows={companies.data.map((x: any) => {
          return { Key: x.id, ...x };
        })}
        totalRowCount={companies.totalRowCount}
        filteredRowCount={companies.filteredRowCount}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filterChange={filterChange}
      />
    </KwPanel>
  ) : (
    <Loading></Loading>
  );
}

export default CompanyStats;
